// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__46+gC","resultsStats":"styles_resultsStats__YnawL"};